import { Component, OnInit, Input, Output, EventEmitter,
      ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';

import { AppConfig } from '../../app.config';
import { UploadService } from '../../services/upload.service';
import { HttpEvent, HttpResponse } from '@angular/common/http';


@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'cool-upload',
  templateUrl: './cool-upload.component.html',
  styleUrls: ['./cool-upload.component.scss']
})
export class CoolUploadComponent implements OnInit {

  @Input() fileLink: string = undefined;
  @Input() readonly = false;
  @Input() preview = false;
  @Input() multiple = false;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('upload-url') uploadUrl: string;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('upload-key') uploadKey = 'file';
  @Output() pick: EventEmitter<File | Array<File>> = new EventEmitter<File | Array<File>>();
  @Output() progress: EventEmitter<number> = new EventEmitter<number>();
  @Output() uploaded: EventEmitter<File | Array<File>> = new EventEmitter<File | Array<File>>();
  @Output() uploadedResponse: EventEmitter<HttpEvent<any>> = new EventEmitter<HttpEvent<any>>();

  @ViewChild('preview', { static: false }) imagePreview: ElementRef;
  @ViewChild('download', { static: false }) downloadLink: ElementRef;
  @ViewChild('input', { static: true }) inputItem: ElementRef;

  public loaded = false;
  public filePicked = false;
  public uploading = false;
  public uploadProgress = 0;

  constructor(
    private cdr: ChangeDetectorRef,
    private uploader: UploadService,
  ) { }

  ngOnInit() {
    if (this.fileLink) {
      this.load(this.fileLink);
    }
    this.inputItem.nativeElement.multiple = this.multiple;
  }

  public get config() { return AppConfig; }

  public dropped(event: NgxFileDropEntry[]) {
    const files = event;

    if (files.length > 0 ) {
      if (files[0].fileEntry.isFile) {
        this.filePicked = true;
        if (this.multiple) {
          const fileEntries = files.map((fe) => fe.fileEntry) as FileSystemFileEntry[];
          fileEntries.map((fe) => fe.file((file) => this.pickFile(file)));
        } else {
          const fileEntry = files[0].fileEntry as any;
          fileEntry.file((file: File) => this.pickFile(file));
        }
      }
    }
  }

  public selected(event) {
    const files: FileList = event.target.files;
    if (files.length > 0) {
      this.filePicked = true;
      if (this.multiple) {
        this.toFileArray(files).map((file) => this.pickFile(file));
      } else {
        this.pickFile(files[0]);
      }
    }
  }

  private toFileArray(fileList: FileList): Array<File> {
    const array = [];
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      array.push(file);
    }

    return array;
  }

  public pickFile(file: File) {
    this.pick.emit(file);
    this.loadPreview(file);

    if (this.uploadUrl) {
      this.uploading = true;
      this.cdr.detectChanges();
      this.uploader.upload(
        this.uploadUrl, this.uploadKey,
        file,
        (loaded: number, total: number) => {
          this.uploadProgress = loaded * 1.0 / total;
          this.cdr.detectChanges();
          this.progress.emit(this.uploadProgress);
        })
        .subscribe(response => {
          setTimeout(() => {
            this.uploading = false;
            this.cdr.detectChanges();
            this.uploaded.emit(file);
            this.uploadedResponse.emit(response);
          }, 500);
        });
    } else {
      this.uploadProgress = 1;
    }
  }

  public loadPreview(file: File) {
    if (this.preview) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagePreview.nativeElement.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  public clear() {
    this.filePicked = false;
    this.uploadProgress = 0;
    this.loaded = false;
  }

  public load(url) {
    this.loaded = true;
    this.filePicked = true;
    this.uploadProgress = 1;
    this.cdr.detectChanges();
    if (this.preview) {
      this.imagePreview.nativeElement.src = url;
    } else {
      this.downloadLink.nativeElement.href = url;
    }
  }
}
